<template>
  <div class="spl-adhoc-drive-filter">
    <div
      v-if="!expanded"
      class="spl-adhoc-drive-filter__collapsed">
      <button
        :disabled="searchActive"
        class="spl-adhoc-drive-filter__text"
        tabindex="1"
        role="button"
        style="grid-column: 1"
        @click="toggleExpand">
        <p>{{ filterText }}</p>
      </button>
      <button
        :disabled="searchActive"
        tabindex="2"
        class="spl-adhoc-drive-filter__icon-button spl-adhoc-drive-filter__edit-filter"
        style="grid-column: 2"
        @click="toggleExpand">
        <img src="../../../assets/icon-edit.svg">
      </button>
      <button
        :disabled="searchActive"
        tabindex="3"
        class="spl-adhoc-drive-filter__icon-button spl-adhoc-drive-filter__refresh"
        style="grid-column: 3"
        @click="handleReload">
        <img src="../../../assets/icon-restore.svg">
      </button>
    </div>
    <div v-else>
      <div class="spl-adhoc-drive-filter__date">
        <div class="spl-adhoc-drive-filter__date--from">
          <form-label>From Date</form-label>
          <form-datepicker v-model="fromDate" />
        </div>
        <div class="spl-adhoc-drive-filter__date--to">
          <form-label>To Date</form-label>
          <form-datepicker v-model="toDate" />
        </div>
      </div>
      <div class="spl-adhoc-drive-filter__multiselects">
        <div class="spl-adhoc-drive-filter__multiselects--country">
          <form-label>Customer</form-label>
          <customer-multiselect
            :selected-keys="localFilter.customers"
            :limit-height="true"
            :placeholder="'Filter by customer'"
            class="spl-adhoc-drive-filter__item"
            style="grid-column: 2"
            @valuesSelected="onCustomersSelected" />
        </div>
        <div class="spl-adhoc-drive-filter__multiselects--customer">
          <form-label>Country</form-label>
          <country-multiselect
            :selected-keys="localFilter.countries"
            :limit-height="true"
            :placeholder="'Filter by country'"
            class="spl-adhoc-drive-filter__item"
            style="grid-column: 3"
            @valuesSelected="onCountriesSelected" />
        </div>
        <div class="spl-adhoc-drive-filter__multiselects--provider">
          <form-label>Provider</form-label>
          <provider-multiselect
            :selected-keys="localFilter.providers"
            :options="activeProviderOptions"
            :limit-height="true"
            :placeholder="'Filter by provider'"
            class="spl-adhoc-drive-filter__item"
            style="grid-column: 3"
            @valuesSelected="onProvidersSelected" />
        </div>
      </div>
      <div class="spl-adhoc-drive-filter__buttons">
        <form-button class="spl-adhoc-drive-filter__apply" @onClick="finishEditing">
          Apply
        </form-button>
        <form-button class="spl-adhoc-drive-filter__clear" @onClick="clearFilter">
          Clear
        </form-button>
        <form-button
          :secondary="true"
          class="spl-adhoc-drive-filter__cancel"
          @onClick="handleCancel">
          Cancel
        </form-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import Helpers from '@/helpers.vue'
import { cloneDeep } from 'lodash'

export default {
  mixins: [Helpers],
  data () {
    return {
      dateFormat: 'dd.MM.yyyy',
      fromDate: moment().toISOString(true),
      toDate: moment().toISOString(true),
      localFilter: {
        customers: [],
        countries: [],
        providers: [],
        fromDate: moment().toISOString(true),
        toDate: moment().toISOString(true)
      },
      expanded: true
    }
  },
  computed: {
    ...mapGetters('adhocDrive', ['adhocDriveList']),
    ...mapGetters('provider', ['activeProviderOptions']),
    ...mapState('adhocDrive', ['adhocDriveFilter']),
    filterText () {
      var text:string = 'Filter - '
      text += 'Date: ' + moment(this.fromDate).format('YYYY-MM-DD') + ' - ' + moment(this.toDate).format('YYYY-MM-DD')
      if (this.localFilter.countries && this.localFilter.countries.length > 0) {
        text += ' | Countries (' + this.localFilter.countries.length + ')'
      }
      if (this.localFilter.customers && this.localFilter.customers.length > 0) {
        text += ' | Customers ('+ this.localFilter.customers.length + ')'
      }
      if (this.localFilter.providers && this.localFilter.providers.length > 0) {
        text += ' | Providers ('+ this.localFilter.providers.length + ')'
      }
      return text
    },
    searchActive () {
      return this.$route.query.search !== undefined
    }
  },
  watch: {
    fromDate: function (newVal) {
      this.localFilter.fromDate = moment(newVal).format()
    },
    toDate: function (newVal) {
      this.localFilter.toDate = moment(newVal).format()
    }
  },
  mounted () {
    if (this.adhocDriveFilter && this.adhocDriveFilter.customers) {
      this.localFilter = cloneDeep(this.adhocDriveFilter)
      this.fromDate = moment(this.localFilter.fromDate).format()
      this.toDate = moment(this.localFilter.toDate).format()
    }
    this.loadAdhocDriveList({
      Customer_IDs: this.localFilter.customers,
      Country_IDs: this.localFilter.countries,
      Provider_IDs: [],
      From_Date: this.localFilter.fromDate,
      To_Date: this.localFilter.toDate
    })
    this.toggleExpand()
  },
  methods: {
    ...mapActions('adhocDrive', ['setFilter', 'sortList', 'loadAdhocDriveList', 'loadAdhocDriveFilter']),
    toggleExpand () {
      this.expanded = !this.expanded
    },
    handleCancel () {
      this.toggleExpand()
    },
    clearFilter () {
      this.localFilter = {
        customers: [],
        countries: [],
        providers: [],
        fromDate: this.formatDate(new Date(), false),
        toDate: this.formatDate(new Date(), false)
      }
      this.onFilterChange()
      this.setCurrentFilter(this.localFilter)
    },
    onCustomersSelected (customers) {
      this.localFilter.customers = customers
    },

    onCountriesSelected (countries) {
      this.localFilter.countries = countries
    },

    onProvidersSelected (providers) {
      this.localFilter.providers = providers
    },

    finishEditing () {
      this.onFilterChange()
      this.toggleExpand()
    },

    onFilterChange () {
      this.loadAdhocDriveList({
        Customer_IDs: this.localFilter.customers,
        Country_IDs: this.localFilter.countries,
        Provider_IDs: [],
        From_Date: this.localFilter.fromDate,
        To_Date: this.localFilter.toDate
      })
      this.setCurrentFilter(this.localFilter)
      this.sortList({ Customer_ID: 'desc' })
    },
    handleReload () {
      this.$emit('onReload')
    },
    setCurrentFilter (filter) {
      this.loadAdhocDriveFilter(filter)
    }
  }
}
</script>

<style lang="scss">
@import '../../../variables.scss';

.spl-adhoc-drive-edit-action-bar {
    background-color: $yellowButtonLabelHover;
    bottom: 0;
    height: 70px;
    padding: 15px $mainPadding;
    position: fixed;
    display: grid;
    grid-template-columns: 150px auto 150px;
    width: 100%;

    .spl-label {
        color: $darkerYellow;
    }
    .spl-input {
        width: 450px;
    }
    .col3 {
        .spl-button {
            background-color: $footerButtonYellow;
            color: $yellowButtonLabel;
            margin: 0 2px 0 0;
            padding: 0 10px;
        }
    }
    .col2 {
        .spl-button {
            background-color: $mainInputColor;
            color: $footerButtonDarkGreyText;
            float: right;
        }
    }
}
.spl-adhoc-drive-filter {
  background-color: $yellowButtonLabelHover;
  position: relative;
  padding: 0 $mainPadding;
  margin-bottom: 15px;
  &--return {
    background: $darkRed;
  }
  &__date {
    display: grid;
    padding: 20px 0;
    width: 100%;
    grid-template-columns: 220px 220px 60px 74px 87px 83px;
    grid-gap: 10px;
    &--from {
      grid-column: 1;
    }
    &--to {
      grid-column: 2;
    }
    &--today {
      grid-column: 3;
    }
    &--last-day {
      grid-column: 4;
    }
    &--last-week {
      grid-column: 5;
    }
    &--last-month {
      grid-column: 6;
    }

    .spl-button {
      margin: 22px 0 0 0;
      padding: 0px;
    }
  }

  &__multiselects {
    display: grid;
    padding: 20px 0;
    width: 100%;
    grid-template-columns: minmax(250px, 2000px)
    minmax(250px, 2000px)
    minmax(250px, 2000px);

    &--country {
      grid-column: 1;
      grid-row: 1;
    }

    &--customer {
      grid-column: 2;
      grid-row: 1;
    }

    &--provider {
      grid-column: 3;
      grid-row: 1;
    }

    grid-gap: 10px;
    .spl-button {
      margin: 22px 7px 0 0;
      padding: 0px 10px;
    }
  }

  &__other {
    display: grid;
    padding: 20px 0;
    width: 100%;
    grid-template-columns: 150px 150px 100px
    minmax(250px, 2000px)
    minmax(250px, 2000px);
    grid-gap: 10px;
    &--postal-from {
      grid-column: 1;
    }
    &--postal-to {
      grid-column: 2;
    }
  }

  &__collapsed {
    display: grid;
    grid-template-columns: auto 50px 50px;
    grid-gap: 10px;
    padding: 10px 0;
    .spl-button {
      margin: 0;
    }
    input {
      margin: 0;
    }
  }

  &__icon-button {
    cursor: pointer;
    background: #111;
    border: 0;
    border-radius: 5px;
    &:focus {
      background-color: #222;
    }
    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }

  &__text {
    width: 100%;
    cursor: pointer;
    background: 0;
    border: 0;
    text-align: left;
    color: white;
    height: 40px;
    font-family: "Open Sans", sans-serif;
    font-weight: 400;
    font-size: 13px;
    p {
      margin: 0;
    }
    &:focus {
      background-color: grey;
    }
    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }
  &__flow {
    margin-bottom: 35px;
  }
  &__apply, &__clear, &__default, &__cancel  {
    width: 150px;
    margin-bottom: 20px
  }
}

@media (max-width: 800px) {
  .spl-adhoc-drive-filter {
    &__date,  &__mutliselects,  &__other {
      grid-template-columns: 100%;
    }
  }
}

@include mobile() {
  .spl-adhoc-drive-filter {
    padding: 3px;

    &__refresh, &__search-input, &__search {
      display: none;
    }
    &__edit {
      margin-right: 5px;
    }
    &__collapsed {
      display: flex;
    }

    &__icon-button {
      width: 40px;
    }
    &__text {
      width: calc(100% - 50px);
    }
    &__date {
      display: inline;
      &--from {
        & .el-input {
          width: 100% !important;
        }
        grid-area: a
      }
      &--to {
        & .el-input {
          width: 100% !important;
        }
        grid-area: b
      }

      & .spl-button {
        margin: 5px;
        height: 35px;
        width: calc(50% - 10px);
        font-size: 14px;
      }
    }

    &__multiselects {
      grid-template-columns: 100%;
      & .spl-multiselect {
        margin-bottom: 5px;
      }
      &--country {
        grid-column: 1;
        grid-row: 1;
      }

      &--customer {
        grid-column: 1;
        grid-row: 2;
      }

      &--adhoc-drivestatus {
        grid-column: 1;
        grid-row: 3;
      }

      &--service-level {
        grid-column: 1;
        grid-row: 4;
      }

      &--current-event {
        grid-column: 1;
        grid-row: 5;
      }
      &--provider {
        grid-column: 1;
        grid-row: 6;
      }
      &--tag {
        grid-column: 1;
        grid-row: 7;
      }
    }
    &__other {
      & .spl-input {
        margin-bottom: 5px;
        height: 40px;
      }
      &--postal-from {
        grid-column: 1;
        grid-row: 1;
      }
      &--postal-to {
        grid-column: 1;
        grid-row: 2;
      }
    }
    &__apply, &__clear, &__default, &__cancel {
      width: auto;
      margin: 0;
      padding: 5px 5px;
    }
    &__buttons {
      display: inline;
      & .spl-button {
        width: calc(50% - 10px);
        margin: 5px;
        height: 39px;
        font-size: 15px;
      }
    }
  }
}

</style>
